import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import Chapter from "./Chapter";

export default function Testimonials() {
  const { content, t, ui } = useSite();

  return (
    <section id="testimonials" className="mx-auto max-w-7xl scroll-mt-28 px-6 py-24" data-testid="testimonials-section">
      <Chapter num="03" title={ui.clientsSay} testId="testimonials-chapter" />
      <div className="grid gap-4 md:grid-cols-3">
        {content.testimonials.map((item, i) => (
          <motion.figure
            key={`${item.name}-${i}`}
            data-testid={`testimonial-card-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="relative rounded-2xl border border-navy-border bg-navy-surface p-7 transition-colors hover:border-volt/50"
          >
            <Quote size={28} className="text-volt/40" />
            <div className="mt-4 flex gap-1">
              {Array.from({ length: item.rating || 5 }).map((_, s) => (
                <Star key={s} size={15} className="fill-volt text-volt" />
              ))}
            </div>
            <blockquote className="mt-4 text-sm leading-relaxed text-slate-300">"{t(item.text)}"</blockquote>
            <figcaption className="mt-6 border-t border-navy-border pt-4">
              <p className="font-display text-lg uppercase tracking-wide text-white">{item.name}</p>
              <p className="font-mono text-xs tracking-wider text-slate-500">{t(item.role)}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
